module.exports = __webpack_public_path__ + "img/SI-main@2x.f0abe41.webp";